module.exports = __webpack_public_path__ + "img/analytics.f2b8c5c.svg";